import { Color, FontWeight } from '@opallabs/gem'
import { fontSizes } from '@opallabs/pulsar'

const label = (theme, styleOverrides = {}) => ({
  color: Color[theme].Text.Default,
  fontSize: fontSizes.caps.medium,
  fontWeight: theme === 'dark' ? FontWeight.SemiBold : FontWeight.Bold,
  textTransform: 'uppercase',
  ...styleOverrides,
})

export const styles = { label }
